import React from "react";
import { InfoOutlined } from "@material-ui/icons";
import { useRequestVerificationKRAModal } from "./modules/utils/useRequestVerificationKRAModal";
import ExlyImage from "common/Components/ExlyImage";
import { COMMON_WIDTH_RESOLUTIONS } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";
import classnames from "classnames";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { UpgradePlanChip } from "features/AdminPanel/modules/UpgradePlanChip/UpgradePlanChip";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { getSectionStates } from "features/AdminPanel/modules/utils/AdminPanel.utils";

export const RequestVerificationKRA = ({ config }) => {
  const isDesktop = useDesktopMediaQuery();
  const { openRequestVerificationModal, requestVerificationConfig } =
    useRequestVerificationKRAModal(config);
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const subSectionConfig = sectionConfig[config?.key];
  const { isPlanLocked } = getSectionStates({
    status: subSectionConfig?.status,
  });

  const {
    text = {},
    backgroundColor = "",
    btn = {},
  } = requestVerificationConfig;

  if (isPlanLocked) {
    return (
      <>
        {!isDesktop && (
          <div className="p-3">
            <UpgradePlanChip />
          </div>
        )}
      </>
    );
  }
  return (
    <div className="tw-flex tw-flex-col tw-w-[90%] tw-mx-5 md:tw-mx-8 tw-mb-6 tw-mt-2 md:tw-mt-[-1.5rem]">
      <div
        className="tw-flex tw-flex-col md:tw-flex md:tw-flex-row tw-rounded-md tw-p-[14px_12px_14px_10px] tw-justify-between"
        style={{ backgroundColor }}
      >
        <div
          className={`tw-flex md:tw-w-[65%] tw-w-full ${
            typeof text.title === "function"
              ? "tw-items-start"
              : "tw-items-center"
          } tw-justify-center tw-gap-2`}
        >
          <InfoOutlined className="tw-w-[18px] tw-h-[18px]" />
          <div
            className="tw-text-[12px] tw-font-normal tw-leading-4 tw-tracking-[0.24px]"
            style={{ color: text.color }}
          >
            {typeof text.title === "function" ? text.title(config) : text.title}
          </div>
        </div>
        {btn?.hidden !== true && (
          <div
            className={classnames(
              "tw-flex tw-border tw-border-solid tw-h-fit tw-items-center tw-justify-center tw-rounded tw-bg-transparent tw-p-[6px_12px] tw-cursor-pointer tw-text-[12px] tw-font-medium tw-leading-normal",
              {
                "tw-pointer-events-none tw-cursor-not-allowed tw-border-0 tw-gap-2 tw-p-[6px_0px]":
                  btn.className === "inProgressBtn",
              }
            )}
            style={{ borderColor: btn.color, color: btn.color }}
            onClick={openRequestVerificationModal}
          >
            {btn.icon && (
              <ExlyImage
                src={btn.icon}
                fetchWidth={COMMON_WIDTH_RESOLUTIONS}
                className="tw-w-[16px] tw-h-[16px]"
              />
            )}
            <div style={{ color: btn.color }}>{btn.btnText}</div>
          </div>
        )}
      </div>
    </div>
  );
};
